import React, { FC } from 'react';
import ReactDOM from 'react-dom';
import TextInput from '../components/Forms/TextInput';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface TokenFormProps {
    securityToken: string;
    setSecurityToken: React.Dispatch<React.SetStateAction<string>>;
    handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
    hasError: boolean;
}

const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9999999;
`;

const StyledForm = styled.form`
    display: flex;
    flex-direction: column;
    width: 400px;
    transition: all 0.3s ease;
`;

const SecurityTokenForm: FC<TokenFormProps> = ({ securityToken, setSecurityToken, handleSubmit, hasError }) => {
    const { t } = useTranslation();

    const content = (
        <div className={'empriva-condoleanceregister-portal empriva-condoleanceregister-root'}>
            <Overlay className="cr-flex cr-center">
                <StyledForm onSubmit={handleSubmit} className="cr-shadow cr-rounded-block cr-bg-white cr-p-lg">
                    <div className={'cr-mb-lg'}>
                        {t('security-token-required-message')}
                    </div>
                    <TextInput
                        label={t('security-token')}
                        name="securityToken"
                        value={securityToken}
                        setValue={setSecurityToken}
                    />
                    {hasError && (
                        <div className={'cr-text-alert cr-my-sm'}>
                            {t('security-token-invalid-message')}
                        </div>
                    )}
                    <button
                        type="submit"
                        className="cr-text-base cr-text-white cr-bg-alert cr-rounded-full cr-p cr-mt cr-shadow"
                    >
                        {t('continue')}
                    </button>
                </StyledForm>
            </Overlay>
        </div>
    );

    const portalTarget = typeof window !== 'undefined'
        ? document.querySelector('body')
        : null;

    return portalTarget ? ReactDOM.createPortal(content, portalTarget) : null;

};

export default SecurityTokenForm;
